import React from 'react';
import Header from './components/Header';
import { Container } from 'react-bootstrap';
import Footer from './components/Footer';
import { Outlet } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SocketListener from './SocketListener';
import { TOAST_DELAY } from './constants';

const App = () => {
  return (
    <div className="app-shell">
      <Header />
      <SocketListener />
      <main className="py-3 app-main">
        <Container>
          <Outlet />
        </Container>
      </main>
      <Footer />
      <ToastContainer 
        autoClose={TOAST_DELAY}
        position='bottom-right'
      />
    </div>
  );
};

export default App;
